export const lastVideoTemplate = (lastVideoThumb, lastVideoLink) =>`
<div class="last-video">
    <a href="${lastVideoLink}">
        <img src="${lastVideoThumb}" />
        <svg class="icon play-circle"><use xlink:href="#icon-play_simp"></use></svg>
    </a>
</div>`